export default "__VITE_ASSET__BiNGwHit__"